import { qltClient } from '../clients';

export interface QltUploadFormat {
  url: string;
  width?: number;
  height?: number;
}

export interface QltUploadFile {
  id: string;
  name: string;
  mime: string;
  ext?: string;
  size: number;
  url: string;
  width?: number;
  height?: number;
  formats?: { thumbnail?: QltUploadFormat; small?: QltUploadFormat; medium?: QltUploadFormat };
}

export const UploadRepository = {
  // Strapi 3 upload plugin: any file type, one multipart field per file
  uploadFiles: (files: File[]) => {
    const data = new FormData();
    files.forEach((file) => data.append('files', file));
    return qltClient.post('/upload', data).then((response) => response.data as QltUploadFile[]);
  },
};

export default UploadRepository;
